import React from 'react';
import { SelectOption } from '../MultiStepForm/types/formFields';
import dropdownIcon from '../../assets/icons/dropdown-carret.svg';

interface SelectProps {
  value?: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  isDisabled?: boolean;
  required?: boolean;
}

const Select: React.FC<SelectProps> = ({
  value,
  onChange,
  options,
  placeholder,
  isDisabled = false,
  required = false
}) => {
  return (
    <div className="form-field__select-wrapper">
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className="form-field__input form-field__select"
        disabled={isDisabled}
        required={required}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <img src={dropdownIcon} alt="Dropdown" className="form-field__select-icon" />  
    </div>
  );
};

export default Select;
